import { hybrid } from 'hybrid-sdk-common';
import { inApp, isInHomeWork, isInKd, isInWakeup } from '@/kits/system';
import urlExt from '@/kits/url';

/**
 * 打开 Web 页面：客户端内使用新 WebView，普通浏览器在当前页面跳转。
 */
export const openWebPage = (pageUrl: string): void => {
  const from = urlExt.getQuery('from');
  const isInClient = inApp || isInHomeWork || isInKd || isInWakeup || from === 'zyb' || from === 'kd';

  if (isInKd || from === 'kd') {
    hybrid('core_openWindow', {
      pageUrl,
      businessData: {
        className_ios: 'KDWebViewController'
      }
    });
  } else if (isInClient) {
    hybrid('core_openWindow', { pageUrl });
  } else {
    window.location.href = pageUrl;
  }
};
